export default {
    SHOW_SUB_STEPS(state, index) {
        if (index === 0) {
            state.steps[index].show = !state.steps[index].show;
        } else {
            if (state.steps[index - 1].done) {
                state.steps[index].show = !state.steps[index].show;
            }
        }
    },
    CURRENT_STEP(state, { index, value }) {
        state.steppers[index].current = value;
    },
    CURRENT_STEP_VOTRE_PROJECT(state, { index, value }) {
        state.votreProjectSteepers[index].current = value;
    },
    COMPLET_STEP_VOTRE_PROJECT(state, { index, value }) {
        state.votreProjectSteepers[index].isCompleted = value;
    },
    SHOW_CURENT_SECTION(state, payload) {
        state.steps[payload.index].show = payload.value;
    },
    FOCUS_CURRENT_STEP(state, { value, index, subIndex }) {
        state.steps[index].subSteps[subIndex].focus = value;
    },
    SUB_STEP_COMPLETED(state, { index, subIndex }) {
        state.steps[index].subSteps[subIndex].done = true;
    },

    BIG_STEP_COMPLETED(state, index) {
        state.steps[index].done = true;
    },

    //simple version

    SHOW_SUB_SV_STEPS(state, index) {
        if (index === 0) {
            state.simpleVersionSteps[index].show = !state.simpleVersionSteps[
                index
            ].show;
        } else {
            if (state.simpleVersionSteps[index - 1].done) {
                state.simpleVersionSteps[index].show = !state
                    .simpleVersionSteps[index].show;
            }
        }
    },
    SHOW_CURENT_SV_SECTION(state, payload) {
        state.simpleVersionSteps[payload.index].show = payload.value;
    },
    FOCUS_CURRENT_SV_STEP(state, { value, index, subIndex }) {
        state.simpleVersionSteps[index].subSteps[subIndex].focus = value;
    },
    SUB_SV_STEP_COMPLETED(state, { index, subIndex }) {
        state.simpleVersionSteps[index].subSteps[subIndex].done = true;
    },

    BIG_SV_STEP_COMPLETED(state, index) {
        state.simpleVersionSteps[index].done = true;
    }
};
